import { GetSearchFacets, GetSearchSuggestions } from '../../../../internal/catalogService';
import { IsCatalogAdvancedLicensed } from '../../../../internal/feature/registeredFeatures';
import { GetPreviousSearches, SetPreviousSearches } from '../../../../internal/service/preferences/access/preferencesServiceAccessorREST';
export const getSearchSuggestions = async searchProps => {
  if (searchProps.facetInfo !== undefined && (searchProps.facetInfo.valueType === 'text' || searchProps.facetInfo.valueType === 'keyword') && searchProps.indices !== undefined && searchProps.initialValue !== undefined) {
    const result = await GetSearchSuggestions({
      limit: searchProps.limit,
      initialValue: searchProps.initialValue,
      indices: searchProps.indices,
      fieldName: searchProps.facetInfo?.name
    });
    return {
      value: searchProps.initialValue,
      suggestions: result,
      indices: searchProps.indices,
      limit: searchProps.limit
    };
  } else {
    return Promise.resolve(null);
  }
};
export const getPreviousSearches = async () => {
  const result = await GetPreviousSearches();
  const previousSearches = [];
  if (result !== null) {
    for (const ps of result) {
      previousSearches.push({
        query: ps.query,
        count: ps.count,
        indicesList: ps.indices,
        timestamp: ps.timestamp
      });
    }
    return previousSearches;
  }
  return null;
};
const MAX_PREVIOUS_SEARCHES = 10;
export const addPreviousSearch = async previousSearch => {
  const previousSearches = await GetPreviousSearches();
  const convertedPreviousSearch = {
    query: previousSearch.query,
    count: previousSearch.count,
    timestamp: previousSearch.timestamp,
    indices: previousSearch.indicesList
  };
  const matchIndex = previousSearches ? previousSearches.findIndex(ps => ps.query && previousSearch.query && ps.query.toLocaleLowerCase().trim() === previousSearch.query.toLocaleLowerCase().trim()) : -1;
  if (previousSearches && matchIndex > -1) {
    previousSearches.splice(matchIndex, 1);
  }
  const newPreviousSearches = previousSearches ? [convertedPreviousSearch, ...previousSearches] : [convertedPreviousSearch];
  if (newPreviousSearches.length > MAX_PREVIOUS_SEARCHES) {
    newPreviousSearches.splice(MAX_PREVIOUS_SEARCHES, newPreviousSearches.length - MAX_PREVIOUS_SEARCHES);
  }
  const result = await SetPreviousSearches(newPreviousSearches);
  const updatedPreviousSearches = [];
  if (result !== null) {
    for (const ps of result) {
      updatedPreviousSearches.push({
        query: ps.query,
        count: ps.count,
        indicesList: ps.indices,
        timestamp: ps.timestamp
      });
    }
    return updatedPreviousSearches;
  }
  return null;
};
export const getSearchFacets = async () => {
  const response = await GetSearchFacets();
  const isCatalogAdvancedLicensed = await IsCatalogAdvancedLicensed();
  const facets = {};
  const collectionLength = response.facets.length;
  if (collectionLength > 0) {
    for (const facetRepr of response.facets) {
      if (facetRepr && (isCatalogAdvancedLicensed || !facetRequiresLicense(facetRepr.name))) {
        // const facetLabel: string = localize('search.filterName.' + facetRepr.name + '.title');
        const facet = {
          name: facetRepr.name,
          valueType: facetRepr.type ? facetRepr.type : 'text',
          indices: facetRepr.indices,
          hiddenIndices: facetRepr.hiddenIndices
          // label: facetLabel.startsWith('NovaComponents') ? facetRepr.name : facetLabel,
        };

        facets[facet.name.toLocaleLowerCase()] = facet;
      }
    }
  }
  return facets;
};

// facetRequiresLicense - Determine if the parameter string matches a list of facets
// that required a license to be displayed to the user
const facetRequiresLicense = facetName => {
  switch (facetName) {
    case 'Classification':
    case 'Column.classification':
    // _C_lassificaiton is a bug in the current facet naming. Can remove the
    // following entry when that name is fixed and we can just use the lowercase entry.
    case 'Column.Classification':
    case 'Column.informationPrivacy':
    case 'Column.semanticType':
    case 'Contacts':
    case 'InformationPrivacy':
    case 'Locale':
    case 'Status':
    case 'Keywords':
    case 'Column.keywords':
    case 'Languages':
    case 'Tags':
    case 'Topic':
    case 'TopicKeywords':
    case 'TopicParent':
      return true;
    default:
      return false;
  }
};
//# sourceMappingURL=api.js.map